import "../stylesheets/App.css";
import "../stylesheets/Error404.css";
import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

function Error404() {
  useEffect(() => {
    const el = document.getElementById("html-ref");
    if (el) el.style.overflowY = "hidden";

    return () => {
      // opcional: restaurar scroll al salir
      if (el) el.style.overflowY = "auto";
    };
  }, []);

  const homePath = useMemo(() => {
    try {
      const raw = localStorage.getItem("user-info");
      const user = raw ? JSON.parse(raw) : null;
      return user?.is_admin ? "/admin" : "/";
    } catch {
      return "/";
    }
  }, []);

  return (
    <div className="error-container">
      <div className="div-404-flotante">
        <h1 className="error-404">404</h1>
      </div>

      <div className="popup-error">
        <div className="orange-div">error</div>
        <div className="white-div">
          <h1>Parece que esta página no existe</h1>
          <Link to={homePath}>
            <p>Ir a la página principal</p>
          </Link>
        </div>
      </div>

      <img
        className="error-img"
        src={process.env.PUBLIC_URL + "/images/login/Login_Banner_Completo.webp"}
        alt="Banner"
      />
    </div>
  );
}

export default Error404;
